import {Asset, DisplayTypes, Pack, TypeofDisplay} from "lib/types";
import { isImage, isVideo } from "../base/link/utils";
import { isAdmin, isOwner } from "lib/utils";

export const getTypeofAsset = (asset: Asset<any>): TypeofDisplay => {
  if (isVideo(asset)) {
    return DisplayTypes.VIDEO;
  }

  if (!!asset.data?.oembed) {
    return DisplayTypes.OEMBED;
  }

  if (isImage(asset))  {
    return DisplayTypes.IMAGE;
  }

  return DisplayTypes.LINK;
};

export const isEditable = (asset, loggedInUser, pack: Pack) => {
  const isModifyingOwnAsset = asset?.user_id === loggedInUser?.id;
  const isAnonEditable = (asset.anon_identifier === pack?.anon?.identifier || asset.user_id === loggedInUser?.id) && (pack?.anon?.identifier || asset?.user_id);

  return isModifyingOwnAsset || isAnonEditable || isAdmin(pack) || isOwner(pack, loggedInUser);
};
